<aside class="sidebar-wrapper mat-elevation-z9" [ngClass]="{'mini-sidebar' : getSideBarSate()}">
  <div class="sidebar-header">
      <img src="../../../assets/images/app/logo.png" width="50">
      <div class="logo-name">BVVS </div>
  </div>
  <nav class="sidebar-menu">

    <mat-accordion class="example-headers-align" multi>

        <mat-nav-list>
          <a mat-list-item routerLink="dashboard/admin"><mat-icon class="material-icons-outlined">dashboard</mat-icon>Dashboard</a>
        </mat-nav-list>

        <mat-expansion-panel [class.mat-elevation-z0]="true" *ngIf="role === 'admin'">
          <mat-expansion-panel-header>
            <mat-icon class="material-icons-outlined">login</mat-icon>Staff
          </mat-expansion-panel-header>
          <mat-nav-list>
            <a mat-list-item routerLink="staff-account-creation"><mat-icon>arrow_right</mat-icon>Account Creation</a>
            <a mat-list-item routerLink="staff-list"><mat-icon>arrow_right</mat-icon>Staff List</a>
          </mat-nav-list>
        </mat-expansion-panel>
        
        <mat-expansion-panel [class.mat-elevation-z0]="true">
          <mat-expansion-panel-header>
            <mat-icon class="material-icons-outlined">description</mat-icon>Student
          </mat-expansion-panel-header>
          <mat-nav-list>
            <a mat-list-item routerLink="student-import"><mat-icon>arrow_right</mat-icon>Import</a>
            <a mat-list-item routerLink="students-lists"><mat-icon>arrow_right</mat-icon>List</a>
          </mat-nav-list>
        </mat-expansion-panel>

        <mat-expansion-panel [class.mat-elevation-z0]="true">
          <mat-expansion-panel-header>
            <mat-icon class="material-icons-outlined">description</mat-icon>Subject Dictionary
          </mat-expansion-panel-header>
          <mat-nav-list>
            <a mat-list-item routerLink="subject-import"><mat-icon>arrow_right</mat-icon>Import</a>
            <a mat-list-item routerLink="subject-lists"><mat-icon>arrow_right</mat-icon>List</a>
          </mat-nav-list>
        </mat-expansion-panel>

        <mat-expansion-panel [class.mat-elevation-z0]="true">
          <mat-expansion-panel-header>
            <mat-icon class="material-icons-outlined">description</mat-icon>Results
          </mat-expansion-panel-header>
          <mat-nav-list>
            <a mat-list-item routerLink="result-import"><mat-icon>arrow_right</mat-icon>Import</a>
            <a mat-list-item routerLink="process-result"><mat-icon>arrow_right</mat-icon>Process</a>
            <a mat-list-item routerLink="result-lists"><mat-icon>arrow_right</mat-icon>Result-List</a>
            <a mat-list-item routerLink="result-processed-list"><mat-icon>arrow_right</mat-icon>Processed-List</a>
            <a mat-list-item routerLink="result-processed-stats"><mat-icon>arrow_right</mat-icon>Processed-Stats</a>
            <a mat-list-item routerLink="NAD-report"><mat-icon>arrow_right</mat-icon>NAD Report</a>
          </mat-nav-list>
        </mat-expansion-panel>
        <mat-expansion-panel [class.mat-elevation-z0]="true">
          <mat-expansion-panel-header>
            <mat-icon class="material-icons-outlined">description</mat-icon>Grade-card
          </mat-expansion-panel-header>
          <mat-nav-list>
            <a mat-list-item routerLink="Grade-card"><mat-icon>arrow_right</mat-icon>GradeCard</a>
          
          </mat-nav-list>
        </mat-expansion-panel>

         <mat-expansion-panel [class.mat-elevation-z0]="true">
          <mat-expansion-panel-header>
            <mat-icon class="material-icons-outlined">description</mat-icon>Overall Result
          </mat-expansion-panel-header>
          <mat-nav-list>
            <a mat-list-item routerLink="overallresult"><mat-icon>arrow_right</mat-icon>Overall Result</a>
          
          </mat-nav-list>
        </mat-expansion-panel>
        <!-- <mat-expansion-panel [class.mat-elevation-z0]="true"> -->

        <!-- <mat-expansion-panel [class.mat-elevation-z0]="true">
          <mat-expansion-panel-header>
            <mat-icon class="material-icons-outlined">lock</mat-icon>Authentication
          </mat-expansion-panel-header>
          <mat-nav-list>
            <a mat-list-item routerLink="auth/sign-in" target="_blank"><mat-icon>arrow_right</mat-icon>SignIn</a>
         
            <a mat-list-item routerLink="auth/sign-up" target="_blank"><mat-icon>arrow_right</mat-icon>SignUp</a>
            <a mat-list-item routerLink="auth/forgot-password" target="_blank"><mat-icon>arrow_right</mat-icon>Forgot Password</a>
            <a mat-list-item routerLink="auth/reset-password" target="_blank"><mat-icon>arrow_right</mat-icon>Reset Password</a>
            <a mat-list-item routerLink="auth/lock-screen" target="_blank"><mat-icon>arrow_right</mat-icon>Lock Screen</a>
          </mat-nav-list>
        </mat-expansion-panel> -->
        <mat-expansion-panel [class.mat-elevation-z0]="true" *ngIf="role === 'admin'">
          <mat-expansion-panel-header>
            <mat-icon class="material-icons-outlined">description</mat-icon>Setting
          </mat-expansion-panel-header>
          <mat-nav-list >
            <a mat-list-item routerLink="scheme-master"><mat-icon>arrow_right</mat-icon>Scheme Master</a>
            <a mat-list-item routerLink="grade-master"><mat-icon>arrow_right</mat-icon>Grade Master</a>
            <a mat-list-item routerLink="Course-master"><mat-icon>arrow_right</mat-icon>Course Master</a>
            <a mat-list-item routerLink="Semester-master"><mat-icon>arrow_right</mat-icon>Semester Master</a>
            <!-- <a mat-list-item routerLink="Course-semester-map"><mat-icon>arrow_right</mat-icon>Course Semester Mapping</a> -->
            <a mat-list-item routerLink="months-list"><mat-icon>arrow_right</mat-icon>months Lists</a>
            <a mat-list-item routerLink="years-list"><mat-icon>arrow_right</mat-icon>year Lists</a>
            <a mat-list-item routerLink="change-course-list"><mat-icon>arrow_right</mat-icon>Branch change List</a>
            <a mat-list-item routerLink="College-data"><mat-icon>arrow_right</mat-icon>College Details</a>
            <!-- <a mat-list-item routerLink="processed-result"><mat-icon>arrow_right</mat-icon>Processed Result List</a> -->
            <a mat-list-item routerLink="processss-result"><mat-icon>arrow_right</mat-icon>Processed Result</a>
             <a mat-list-item routerLink="result-master"><mat-icon>arrow_right</mat-icon>Result Master</a>
             <a mat-list-item routerLink="date-of-result"><mat-icon>arrow_right</mat-icon>Date Of Result</a>
          </mat-nav-list>
        </mat-expansion-panel>
        <mat-nav-list>
          <a mat-list-item routerLink="profile/user-profile"><mat-icon class="material-icons-outlined">account_circle</mat-icon>User Profile</a>
        </mat-nav-list>
    
       
        <!-- <mat-expansion-panel [class.mat-elevation-z0]="true">
          <mat-expansion-panel-header>
            <mat-icon class="material-icons-outlined">leaderboard</mat-icon>Charts
          </mat-expansion-panel-header>
          <mat-nav-list>
            <a mat-list-item routerLink="charts/chart-js"><mat-icon>arrow_right</mat-icon>Chart Js</a>
            <a mat-list-item routerLink="charts/apex-chart"><mat-icon>arrow_right</mat-icon>Apex Chart</a>
          </mat-nav-list>
        </mat-expansion-panel> -->
        
        <!-- <mat-nav-list>
          <a mat-list-item href="#" target="_blank"><mat-icon class="material-icons-outlined">description</mat-icon>Help</a>
        </mat-nav-list> -->
      
    </mat-accordion>
    
  </nav>
</aside>
